// @flow strict

import type {
  TimeOff,
  BookingSlot,
  AgentSettings,
  AgentApiParams,
} from 'src/types/scheduler/settings.js';
//$FlowFixMe[nonstrict-import]
import type {State} from 'src/reducers';
import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu/Menu';
import {getLanguageLabelFromKey} from 'src/components/scheduler/settings/utils';


export const selectAgentSettings = (state: State): AgentSettings => {
  return state.scheduler.settings.agentSettings;
};

export const selectUPN = (state: State): string => {
  return state.scheduler.settings.agentSettings.userPrincipalName;
};

export const selectAgentApiParams = (state: State): AgentApiParams => {
  return state.scheduler.settings.agentApiParams;
};

export const selectDailyDigest = (state: State): boolean => {
  return state.scheduler.settings.agentSettings.schedulerEnableDailyDigest;
};

export const selectMaxEventsPerDay = (state: State): number => {
  return state.scheduler.settings.agentSettings.schedulerMaxEventsPerDay;
};

export const selectTimezone = (state: State): string => {
  return state.scheduler.settings.agentSettings.timezone;
};

export const selectBookingHours = (state: State): BookingSlot[] => {
  return state.scheduler.settings.agentSettings.businessHours;
};

export const selectTimeOffs = (state: State): TimeOff[] => {
  return state.scheduler.settings.agentSettings.timeOff;
};

export const selectLanguage = (state: State): string => {
  return state.scheduler.settings.agentSettings.agentLanguage || 'en';
};

export const getTranslationOptionsForScheduler = (
  state: State,
): MenuOption[] => {
  const allLanguagesMapping = state.chat.languageTranslation.languages;
  const languagesNameKeys: string[] = Object.keys(allLanguagesMapping);

  // if no languages are there in redux state (means: API failed), return empty array, don not append fr-CA
  if (languagesNameKeys.length === 0) {
    return [];
  }

  // map all languages to options
  const supportedLanguagesOptions = languagesNameKeys.map((languageName) => {
    const key = allLanguagesMapping[languageName];
    return {key, label: getLanguageLabelFromKey(key, languageName)};
  });

  // List of languages supported for the scheduler (translation only).
  // These languages are currently supported for translation purposes,
  // but not for language detection, as this data is not yet provided by the Messaging API.
  // Temporarily hardcoded — TODO(Aditya): to be removed once detection support is available via the API or we get only translation supported languages from messaging api.
  const extraOptions = [{key: 'fr-CA', label: 'Français canadien'}];

  return [...extraOptions, ...supportedLanguagesOptions];
};
